module.exports = __webpack_public_path__ + "static/media/Seaglass-logo-transparent.c875b11b.png";